import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SalesForecastDetails = () => {
  const { forecastId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const decodedId = forecastId ? atob(forecastId) : forecastId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES.salesForecast}${id}/` : null;
  const { data: forecast, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!forecast) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(forecast)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [forecast]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.salesForecast}${id}/`);
      showToast('Sales forecast deleted successfully', 'success');
      navigate('/customer/sales-forecast/list');
    } catch (error) {
      console.error('Error deleting sales forecast:', error);
      showToast('Error deleting sales forecast', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={forecast}
        columns={columns}
        loading={loading}
        entityName="Sales Forecast"
        listPath="/customer/sales-forecast/list"
        editPath={`/customer/sales-forecast/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Sales Forecast"
        message="Are you sure you want to delete this sales forecast?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SalesForecastDetails;
